import { useEffect, useState } from "react";
import {
  fetchCityLaunchControls,
  updateCityLaunchControl,
} from "../../utils/adminCityLaunch";

function CityLaunchManager() {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCities();
  }, []);

  const loadCities = async () => {
    try {
      setLoading(true);
      const data = await fetchCityLaunchControls();
      setCities(data);
    } catch (error) {
      console.error(error);
      alert(error.message || "Failed to load city controls.");
    } finally {
      setLoading(false);
    }
  };

  const toggleField = async (city, field) => {
    try {
      await updateCityLaunchControl(city.id, {
        [field]: !city[field],
      });

      setCities((prev) =>
        prev.map((item) =>
          item.id === city.id ? { ...item, [field]: !item[field] } : item
        )
      );
    } catch (error) {
      console.error(error);
      alert(error.message || "Failed to update city.");
    }
  };

  if (loading) {
    return <div style={card}><p>Loading city launch controls...</p></div>;
  }

  return (
    <div style={card}>
      <h2 style={{ marginTop: 0 }}>City Launch Control</h2>
      <p style={{ color: "#666" }}>
        Keep India-ready coverage in system, but go live city by city from admin.
      </p>

      <div style={{ display: "grid", gap: "16px", marginTop: "20px" }}>
        {cities.map((city) => (
          <div key={city.id} style={cityCard}>
            <h3 style={{ marginTop: 0 }}>
              {city.city_name}, {city.state_name}
            </h3>

            <div style={row}>
              <Toggle
                label="City Live"
                checked={city.is_live}
                onChange={() => toggleField(city, "is_live")}
              />
              <Toggle
                label="Services"
                checked={city.services_enabled}
                onChange={() => toggleField(city, "services_enabled")}
              />
              <Toggle
                label="Materials"
                checked={city.materials_enabled}
                onChange={() => toggleField(city, "materials_enabled")}
              />
              <Toggle
                label="Workers"
                checked={city.workers_enabled}
                onChange={() => toggleField(city, "workers_enabled")}
              />
              <Toggle
                label="Shops"
                checked={city.shops_enabled}
                onChange={() => toggleField(city, "shops_enabled")}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function Toggle({ label, checked, onChange }) {
  return (
    <label style={toggleWrap}>
      <span>{label}</span>
      <button
        onClick={onChange}
        type="button"
        style={{
          ...toggleBtn,
          background: checked ? "#16a34a" : "#d1d5db",
          color: checked ? "#fff" : "#111",
        }}
      >
        {checked ? "ON" : "OFF"}
      </button>
    </label>
  );
}

const card = {
  background: "#111",
  color: "#fff",
  padding: "24px",
  borderRadius: "18px",
  border: "1px solid #2a2a2a",
};

const cityCard = {
  background: "#181818",
  padding: "18px",
  borderRadius: "14px",
  border: "1px solid #2a2a2a",
};

const row = {
  display: "flex",
  flexWrap: "wrap",
  gap: "12px",
  marginTop: "12px",
};

const toggleWrap = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  background: "#0b0b0b",
  padding: "10px 12px",
  borderRadius: "10px",
};

const toggleBtn = {
  border: "none",
  borderRadius: "999px",
  padding: "8px 12px",
  cursor: "pointer",
  fontWeight: 700,
};

export default CityLaunchManager;